import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { TMainLayoutState, TMainLayoutStore } from "./MainLayout.types";

const initialMainLayoutState: TMainLayoutState = {
  isSidebarCollapsed: true,
};

export const useMainLayoutStore = create<TMainLayoutStore>()(
  devtools(set => ({
    ...initialMainLayoutState,
    setIsSidebarCollapsed: (collapsed: boolean) => {
      set({
        isSidebarCollapsed: collapsed,
      }, undefined, "mainLayout/setIsSidebarCollapsed");
    },
  })),
);
